import { render, staticRenderFns } from "./ResultByPriceMobileView.vue?vue&type=template&id=5dd5b5f1&scoped=true&"
import script from "./ResultByPriceMobileView.vue?vue&type=script&lang=js&"
export * from "./ResultByPriceMobileView.vue?vue&type=script&lang=js&"
import style0 from "./ResultByPriceMobileView.vue?vue&type=style&index=0&id=5dd5b5f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd5b5f1",
  null
  
)

export default component.exports